<div class="container">
    <div class="story-card" [ngSwitch]="variant">
        <h2 class="main-title" *ngIf="data.mainTitle">{{ data.mainTitle }}</h2>
        <div class="content" *ngSwitchCase="storycardVariants.Bullet">
            <ng-container *ngTemplateOutlet="list"></ng-container>
        </div>
        <div class="content" *ngSwitchCase="storycardVariants.Icons">
            <ng-container *ngTemplateOutlet="list"></ng-container>
        </div>
        <div class="content" *ngSwitchDefault>
            <ng-container *ngTemplateOutlet="default"></ng-container>
        </div>
    </div>
</div>

<!-- Default Template -->
<ng-template #default>
    <div class="section"
        [finderScrollTo]="paragraph | getStorycardId"
        [class.top-separator]="!paragraph.copy?.length && i !== 0"
        *ngFor="let paragraph of data.sections; index as i">
        <ng-container
            *ngTemplateOutlet="card; context: {$implicit: paragraph}">
        </ng-container>
    </div>
</ng-template>

<ng-template #list>
    <div
        class="section"
        *ngFor="let paragraph of data.sections"
        [ngClass]="{'icon-section': paragraph.icon}"
        [finderScrollTo]="paragraph | getStorycardId"
    >
        <ul [ngClass]="{'bullet-list': !paragraph.icon, 'icon-list': paragraph.icon}" *ngIf="paragraph.title else noTitle">
            <li class="list-item">
                <div *ngIf="!paragraph.icon; else icon">
                    <ng-container
                        *ngTemplateOutlet="card; context: {$implicit: paragraph}">
                    </ng-container>
                </div>
                <ng-template #icon>
                    <finder-font-icon [name]="paragraph.icon" size="m"></finder-font-icon>
                    <span class="info-container">
                        <ng-container
                            *ngTemplateOutlet="card; context: {$implicit: paragraph}">
                        </ng-container>
                    </span>
                </ng-template>
            </li>
        </ul>
        <ng-template #noTitle>
            <div class="copy" *ngFor="let copy of paragraph.copy">
                <div class="dynamic-html" [innerHTML]="copy | safeHtml"></div>
            </div>
        </ng-template>
    </div>
</ng-template>

<ng-template #card let-paragraph>
    <a class="link" *ngIf="paragraph.link; else content"
        finderLocale
        finderLinkId
        finderRouterLink
        href="{{ paragraph.link }}">
        <ng-container
            *ngTemplateOutlet="content">
        </ng-container>
    </a>
    <ng-template #content>
        <finder-picture *ngIf="paragraph.image" class="image circle" [picture]="paragraph.image"></finder-picture>
        <div
            class="card-content"
            [ngClass]="paragraph.style"
            [class.grouping-card]="!paragraph.copy?.length"
        >
            <div class="title-container">
                <h2 *ngIf="paragraph.titleElement; else elseBlock" class="title" [finderScrollTo]="paragraph.titleElement | getStorycardId">
                    {{ paragraph.titleElement.innerText }}
                </h2>
                <ng-template #elseBlock>
                    <h2 *ngIf="paragraph.title" class="title" [innerHTML]="paragraph.title | safeHtml"></h2>
                </ng-template>
                <finder-font-icon name="next-2" *ngIf="paragraph.link"></finder-font-icon>
            </div>
            <div class="copy" *ngFor="let copy of paragraph.copy">
                <div class="dynamic-html" [innerHTML]="copy | safeHtml"></div>
            </div>
            <finder-button anchor="true" *ngIf="paragraph.moreInfo" (click)="openModal(paragraph)">
                {{ paragraph.readMoreTitle }}
            </finder-button>
            <div class="more-info" *ngIf="paragraph.moreInfo" aria-hidden="true" [innerHTML]="paragraph.moreInfo | safeHtml"></div>
        </div>
    </ng-template>
</ng-template>
